export default {
  components: {},

  props: {
    cellSize: {
      type: Number,
      default: 1,
    },
    cellsCount: Number,
    errorMessage: String,
    isLoading: Boolean,
    isCleared: Boolean,
    label: String,
    successState: Boolean,
    defaultCode: String,
    placeholder: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      code: [],
      isSuccess: this.successState || false,
      isError: false,
      cellWidth: this.cellWidth,
      oversize: true,
      key: null,
    };
  },

  watch: {
    isCleared() {
      if (this.isCleared) {
        this.code = [];
      }
    },
  },

  mounted() {
    if (!this.defaultCode) {
      this.$refs['code-item'][0].focus();
    }
  },

  methods: {
    success() {
      this.isSuccess = true;
    },

    error() {
      this.isError = true;
    },

    clear() {
      this.code = [];
    },

    onInput(index, e) {
      if (!e.target.value) {
        return;
      }
      this.isError = false;
      this.$emit('onInput');

      // Исправление бага в Chrome на iOS
      // При вставке кода из СМС срабатывает событие input, а не paste
      if (e.data && e.data.length > this.cellSize) {
        this.pasteData(index, e.data);

        return;
      }

      if (e.target.value.length > this.cellSize) {
        this.code[index] = e.target.value;
      }

      window.console.log();

      if (this.code[index].length === this.cellSize) {
        this.focusNextOrBlurCurrent(e);
      }
    },

    onPaste(index, e) {
      e.preventDefault();

      let pasteData = (e.clipboardData || window.clipboardData).getData('text');

      const regexp = new RegExp(`.{1,${this.cellSize}}`, 'g');

      pasteData = pasteData
        .replace(/\s/g, '')
        .substr(0, (this.cellsCount * this.cellSize) - (index * this.cellSize))
        .match(regexp);

      this.pasteData(index, pasteData);
    },

    pasteData(index, pasteData) {
      const nodeElements = this.$refs['code-item'];

      for (
        let i = 0;
        i < nodeElements.length && !Number.isNaN(Number(pasteData[i]));
        i += 1
      ) {
        nodeElements[i + index].value = pasteData[i];

        this.code[i + index] = pasteData[i];
      }

      const codeString = this.code.join('');
      this.key = Math.random().toString(36).substr(2, 9);

      if (pasteData.length + index < this.cellsCount) {
        nodeElements[pasteData.length].focus();
      } else {
        nodeElements[index].blur();

        this.sendCode(codeString);
      }
    },

    // Запрет ввода символов, кроме цифр
    onKeypress(e) {
      const keyCode = e.which || e.keyCode;

      if (
        !(
          this.isNumberKeyCode(keyCode)
          || this.isTab(keyCode)
          || this.isBackspace(keyCode)
          || this.isMetaKey(e, keyCode)
        )
      ) {
        e.preventDefault();
      }
    },

    // Переход между input'ами
    onKeydown(index, e) {
      const { parentNode } = e.target;
      const keyCode = e.which || e.keyCode;
      let sibling;

      if (this.isBackspace(keyCode)) {
        this.$emit('onInput');
        // Исправление бага на iOS
        // Необходимо очищать input при нажатии на Backspace,
        // чтобы перед цифрой не добавлялся символ '\n'
        if (e.target.value) {
          e.target.parentNode.lastChild.value = '';
          this.code[index] = '';

          return;
        }

        sibling = parentNode.previousSibling;

        if (sibling) {
          sibling.lastChild.focus();
        }
      } else if (this.isLeftArrow(keyCode) || this.isRightArrow(keyCode)) {
        if (this.isLeftArrow(keyCode)) {
          sibling = parentNode.previousSibling;
        } else {
          sibling = parentNode.nextSibling;
        }

        if (sibling && sibling.lastChild) {
          sibling.lastChild.focus();
        }
      }
    },

    focusNextOrBlurCurrent(e) {
      const { parentNode } = e.target;
      const { nextSibling } = parentNode;

      if (nextSibling && nextSibling.lastChild) {
        nextSibling.lastChild.focus();
      } else {
        parentNode.lastChild.blur();

        this.sendCode(this.code.join(''));
      }
    },

    isNumberKeyCode(keyCode) {
      return keyCode >= 48 && keyCode <= 57;
    },

    isTab(keyCode) {
      return keyCode === 9;
    },

    isBackspace(keyCode) {
      return keyCode === 8;
    },

    isMetaKey(e, keyCode) {
      return e.metaKey && keyCode === 118;
    },

    isLeftArrow(keyCode) {
      return keyCode === 37;
    },

    isRightArrow(keyCode) {
      return keyCode === 39;
    },

    setSelected(e) {
      e.target.select();

      this.$emit('setFocus');
    },

    sendCode(codeString) {
      this.$emit('onInput');
      this.$emit('onComplete', codeString);
    },

    async computeOversize(loop = false) {
      const node = await document.getElementsByClassName('inputs-line');

      if (!node[0]) {
        if (this.intervalId) {
          clearInterval(this.intervalId);
        }
        return;
      }

      this.oversize = !!this.cellWidth * this.cellsCount > node[0].offsetWidth;

      if (loop) {
        return;
      }

      this.intervalId = setInterval(() => {
        this.computeOversize(true);
      }, 300);
    },
  },

  created() {
    const regexp = new RegExp(`.{1,${this.cellSize}}`, 'g');
    this.placeholderData = [];
    this.baseCellWidth = 30;
    this.oneSymbolwidth = 15;
    this.cellWidth = this.baseCellWidth + (this.oneSymbolwidth * this.cellSize);

    if (this.defaultCode) {
      this.code = this.defaultCode
        .replace(/\s/g, '')
        .substr(0, (this.cellsCount * this.cellSize))
        .match(regexp);
    }

    if (this.placeholder) {
      this.placeholderData = this.placeholder
        .replace(/\s/g, '')
        .substr(0, (this.cellsCount * this.cellSize) - (0 * this.cellSize))
        .match(regexp);
    }

    this.computeOversize();
  },
};
